import { Component, Input } from '@angular/core';

/** Botão "Filtros" exibido só no mobile (CSS), que mostra ou esconde os blocos de filtro da tela. */
@Component({
  selector: 'ss-filters-toggle',
  template: `
    <button type="button" class="ss-btn outline-primary ss-btn--sm ss-filters-toggle__button" [attr.aria-expanded]="expanded" (click)="toggled()">
      <lucide-icon name="sliders-horizontal" [size]="16" aria-hidden="true"></lucide-icon>
      Filtros
      <lucide-icon [name]="expanded ? 'chevron-up' : 'chevron-down'" [size]="16" aria-hidden="true"></lucide-icon>
    </button>
  `,
  host: { class: 'ss-filters-toggle' },
  standalone: false
})
export class FiltersToggleComponent {
  @Input() expanded = false;
  @Input() toggled: () => void = () => undefined;
}
